import {createFeatureSelector, createSelector} from "@ngrx/store";
import {StoreState} from "./store.reducer";
import * as _ from 'lodash';

export const selectStoreState = createFeatureSelector<StoreState>('store');
export const selectCompany = createSelector(selectStoreState, (state: StoreState) => state.company);
export const selectCurrentRestaurant = createSelector(selectStoreState, (state: StoreState) => state.currentRestaurant);
export const selectRestaurants = createSelector(selectStoreState, (state: StoreState) => state.restaurants);
export const selectSubscription = createSelector(selectStoreState, (state: StoreState) => state.subscription);
